import image from './image';

const partenaires = [
    {
        href:"https://www.cfaogroup.com/en/division/cfao-consumer/",
        scr:image.logoCfaoConsumerRetails,
        alt:"logo cfa consumer retails",
    },
    {
        href:"https://microfinance-ccm.com",
        scr:image.logoCRM,
        alt:"logo Engie",

    },
    {
        href:"http://www.groupecrebat.com/",
        scr:image.logoCrebat,
        alt:"logo Razel",

    },
    {
        href:"https://aspacintl.com/",
        scr:image.logoAspac,
        alt:"logo Aspac",
    },
    {
        href:"#",
        scr:image.ccn,
        alt:"logo ccn",

    },
    {
        href:"https://crid-cam.net/",
        scr:image.logoCrid,
        alt:"logo crid",

    },
    {
        href:"https://www.unops.org/",
        scr:image.logoUNDPS,
        alt:"logo UNoPS",
    },
    {
        href:"https://www.unesco.org",
        scr:image.unesco,
        alt:"logo unesco"
    },
    {
        href:"https://aspac-engineering.com/,",
        scr:image.aspac_engineering,
        alt:"aspac engineering logo with link to website"
    },
    {
        href:"https://cdimsarl.com/",
        scr:image.cdim,
        alt:"logo unesco",
    },
    {
        href:"https://www.facebook.com/amtisstudio/",
        scr:image.amtis,
        alt:"logo amtis",

    },
    {
        href:"https://www.facebook.com/ndeforcobarchitects/",
        scr:image.nfa,
        alt:"logo nfa",
    },
]

export default {
    partenaires
}